import { render, staticRenderFns } from "./PaymentRecords.vue?vue&type=template&id=ac4ca88c&scoped=true&"
import script from "./PaymentRecords.vue?vue&type=script&lang=js&"
export * from "./PaymentRecords.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRecords.vue?vue&type=style&index=0&id=ac4ca88c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4ca88c",
  null
  
)

export default component.exports